import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useAct } from 'DashboardBuilder/store'
import { selectInvalidDashboardFields } from 'DashboardBuilder/store/dashboardFields'

import './styles/DashboardField.scoped.scss';
import DashboardField from './DashboardField';

export default function DashboardFieldList() {
  const act = useAct();
  const dashboardFields = useSel(s => _.values(s.dashboardFields.entities).filter(f => f.active));
  const orderedDashboardFields = _.orderBy(dashboardFields, ['digitOrder'], ['asc']);

  const invalidFieldIds = useSel(s => selectInvalidDashboardFields(s).map(f => f.id));

  const handleDragEnd = (result) => {
    const { draggableId, destination } = result;
    if (!destination) return;

    const isNumericString = (str) => /^\d+$/.test(str);

    const dashboardFieldId = isNumericString(draggableId) ? parseInt(draggableId) : draggableId // can be uuid
    const destDigitOrder = destination.index + 1; // 1-indexed

    act.dashboardFields.moveDigitOrder(dashboardFieldId, destDigitOrder);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="dashboard-fields">
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="dashboard-fields-container"
          >
            {orderedDashboardFields.map((field, index) => (
              <Draggable key={field.id} draggableId={String(field.id)} index={index}>
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    className={`dashboard-field ${invalidFieldIds.includes(field.id) ? ' invalid' : ''}`}
                  >
                    <div {...provided.dragHandleProps} className="drag-handle">⣿</div>
                    <DashboardField id={field.id} />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

